"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDynamicComponents = void 0;
var _react = require("react");
var _DynamicComponentProvider = require("../providers/DynamicComponentProvider");
const useDynamicComponents = () => {
  return (0, _react.useContext)(_DynamicComponentProvider.DynamicComponentContext);
};
exports.useDynamicComponents = useDynamicComponents;